"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLazy = void 0;
function createLazy(factory) {
    const _factory = factory;
    let _instance = undefined;
    const res = {
        get value() {
            if (_instance === undefined) {
                _instance = _factory();
            }
            return _instance;
        },
        get hasValue() { return _instance !== undefined; },
        reset: () => {
            _instance = undefined;
        },
        dispose: () => res.reset(),
    };
    return res;
}
exports.createLazy = createLazy;
//# sourceMappingURL=light.js.map